import { brandConfig } from 'brand-config';

/**
 * Hook to access brand-specific feature flags
 * @returns {Object} Feature flags for the current brand
 * @returns {Object} discounts - Discount-related feature flags
 * @returns {boolean} discounts.hasFutureEffectiveDateDiscount - Whether the brand supports FED discount
 * @returns {boolean} discounts.hasAdvanceQuoteDiscount - Whether the brand supports AQD discount
 * @returns {boolean} discounts.hasCropInsuranceDiscount - Whether the brand supports crop insurance discount (CFM only)
 * @returns {boolean} discounts.hasTraditionsDiscount - Whether the brand supports traditions discount (CFM only)
 * @returns {boolean} discounts.hasAssociationDiscount - Whether the brand supports MO Farm association discount (CFM only)
 * @returns {boolean} discounts.hasMultilineDiscount - Whether the brand supports multiline discount (CFM only)
 * @returns {boolean} discounts.hasPaperlessDiscount - Whether the brand supports paperless discount (Branch only)
 */
function useBrandFeatures() {
  const discountsConfig = brandConfig?.features?.discounts || {};

  return {
    discounts: {
      hasFutureEffectiveDateDiscount: discountsConfig.hasFutureEffectiveDateDiscount ?? true,
      hasAdvanceQuoteDiscount: discountsConfig.hasAdvanceQuoteDiscount ?? true,
      // CFM Specific, disabled unless explicitly enabled in config
      hasCropInsuranceDiscount: discountsConfig.hasCropInsuranceDiscount ?? false,
      hasTraditionsDiscount: discountsConfig.hasTraditionsDiscount ?? false,
      hasAssociationDiscount: discountsConfig.hasAssociationDiscount ?? false,
      hasMultilineDiscount: discountsConfig.hasMultilineDiscount ?? false,
      // Not available in farm yet, disabled unless explicitly enabled in config
      hasPaperlessDiscount: discountsConfig.hasPaperlessDiscount ?? false
    }
  };
}

export default useBrandFeatures;
